import React from "react";
import { TabLink } from "./__styles__/TabItem";
import { Body } from "./Typography";

export default <T extends string>({
  value,
  active,
  activeTabStyle = "underline",
  setTab,
  children,
  color,
}: {
  value: T;
  active: boolean;
  activeTabStyle: "underline" | "outline";
  setTab: (value: T) => void;
  children: React.ReactNode;
  color: "blue" | "grey";
}) => (
  <TabLink
    onClick={() => setTab(value)}
    active={active}
    activeTabStyle={activeTabStyle}
    color={color}
    aria-selected={active}
  >
    <Body size="default" type="emphasis" color="inherit">
      {children}
    </Body>
  </TabLink>
);
